import 'reflect-metadata';
import { Service } from 'typedi';
import type { PaginationTypeStrategyData } from '../../types/pagination-strategy-data.type';
import { StrategyBuilder } from '../../StrategyBuilder';
import { PaginationStrategyService } from '../../PaginationStrategyService';

@Service({ id: 'searchPaginationFallbackStrategyService' })
export class SearchPaginationFallbackStrategyBuilder extends StrategyBuilder<PaginationStrategyService> {
  build(details: PaginationTypeStrategyData): PaginationStrategyService {
      return new SearchPaginationFallbackStrategyService(details);
  }
}

export class SearchPaginationFallbackStrategyService extends PaginationStrategyService {
  details;
  constructor(details: PaginationTypeStrategyData) {
      super();
      this.details = details;
  }

  makePagination(): string {
      return 'uiaas-tabs-pagination';
  }

  getPaginationProps(
    params: Record<string, string>
  ): Record<string, string> {
      if (this.details?.params) {
        return this.details.params;
      }
      return {};
  }
}
